import * as React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { StaticImage } from "gatsby-plugin-image";

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyLoad from "react-lazy-load";

const AwardsMain = ({
  sectionClass = '',
  hide = true
}) => {

  const Logo5 = '../images/award-partner-certification/gesia.png';
  const Logo6 = '../images/award-partner-certification/cmmi.png';
  const Logo7 = '../images/award-partner-certification/nasscom.png';
  const Logo8 = '../images/award-partner-certification/iso-9001.png';
  const Logo14 = '../images/award-partner-certification/iso-27001.png';

  if (hide) return null;
  
  return (
    <>
      <section className={`section border-top py-3 ${sectionClass}`} >
        <Container>
          <div className="d-none d-lg-block">
            <div className="mb-0">
              {/* <h3 className="mb-4">Our accreditations: Certified for excellence</h3> */}
              <Row className="g-4 align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
                <Col>
                  <div className="equal-height logo-5">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-6">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-7">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-8">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-14">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="d-block d-lg-none">
            <div className="mb-0">
              {/* <h3 className="mb-4">Our accreditations: Certified for excellence</h3> */}
              <LazyLoad>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  navigation={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                  }}
                >
                  <SwiperSlide>
                    <div className="equal-height logo-5">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-6">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-7">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-8">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-14">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </LazyLoad>
            </div>
          </div>

          {/* <div className="d-none d-lg-block">
      <Row className="g-4 award-partner-certification align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
        <Col>
          <div className="equal-height logo-5">
            <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-6">
            <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-7">
            <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-8">
            <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-14">
            <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-1">
            <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-3">
            <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-4">
            <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-13">
            <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-18">
            <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-9">
            <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-10">
            <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-11">
            <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-12">
            <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-2">
            <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-15">
            <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-16">
            <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-17">
            <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
          </div>
        </Col>
        <Col>
          <div className="equal-height logo-19">
            <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
          </div>
        </Col>
      </Row>
    </div> */}
          {/* <div className="d-block d-lg-none">
      <LazyLoad>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          navigation={false}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          }}
          className="award-partner-certification"
        >
          <SwiperSlide>
            <div className="equal-height logo-5">
              <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-6">
              <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-7">
              <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-8">
              <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-14">
              <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-1">
              <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-3">
              <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-4">
              <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-13">
              <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-18">
              <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-9">
              <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-10">
              <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-11">
              <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-12">
              <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-2">
              <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-15">
              <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-16">
              <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-17">
              <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="equal-height logo-19">
              <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
            </div>
          </SwiperSlide>
        </Swiper>
      </LazyLoad>
    </div> */}
        </Container>
      </section>

    </>
  )

}

export default AwardsMain;
